module.exports = __webpack_public_path__ + "static/media/Apple MacBook Air 13\" Space Grey.c3629ac2.png";